
import videojs from 'video.js';

export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      required: true,
    },
    thumbnailVtt: {
      type: String,
      required: false,
    },
    startTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    source() {
      return `${process.env.filmNodeEgress}/${this.videoId}`;
    },
  },
  mounted() {
    this.initializePlayer();
    this.$emit('mounted');
  },
  beforeDestroy() {
    if (this.player) {
      // Remove event listeners
      this.player.off('play');
      this.player.off('pause');
      this.player.off('seeked');
      this.player.off('ended');

      // Dispose of the player instance
      this.player.dispose();
    }
  },
  methods: {
    initializePlayer() {
      this.player = videojs(this.$refs.videoPlayer);
      this.player.fill(true);
      this.player.on('play', () => {
        this.$emit('play');
      });

      this.player.on('pause', () => {
        this.$emit('pause');
      });

      this.player.on('seeked', () => {
        this.$emit('seeked', this.player.currentTime());
      });

      this.player.on('ended', () => {
        this.$emit('ended');
      });

      this.player.ready(() => {
        this.player.currentTime(this.startTime);
      });
      if (this.thumbnailVtt) {
        // Assuming you have the plugin for thumbnails
        // player.vttThumbnails({ src: this.thumbnailVtt });
      }
    },
    getVideoDuration() {
      if (this.player) {
        return this.player.duration();
      }
      return 0;
    },
    getVideoCurrentTime() {
      if (this.player) {
        return this.player.currentTime();
      }
      return 0;
    },
    isPaused() {
      if (this.player) {
        return this.player.paused();
      }
      return true;
    },
  },
};
